"use strict";

import debounce from "lodash/debounce";

export default class Dropdown {
    constructor(element) {
      this.el = element;
      this.menu = this.el.querySelector('div[role="menu"]');
      this.trigger = this.el.querySelector("button[aria-haspopup='true']");
      this.inner = this.el.querySelector(".inner");
      this.options = this.el.querySelectorAll("button[role='menuitem']");
      this.height = this.menu.clientHeight;
  
      this.listen();
      this.close();
    }
    close() {
      this.el.classList.remove("active");
      this.menu.style.maxHeight = "0";
    }
    open() {
      document.querySelectorAll(".dropdown").forEach((dropdown) => {
        const openDropdown = document.querySelector(".dropdown.active");
        if (openDropdown && openDropdown !== dropdown) {
          openDropdown.classList.remove("active");
          openDropdown.querySelector("div[role='menu']").style.maxHeight = "0";
        }
      });
      this.el.classList.add("active");
      const menuHeight = this.inner.clientHeight;
      this.menu.style.maxHeight = menuHeight + 'px';
      window.addEventListener(
        "resize",
        debounce(() => {
          this.menu.style.maxHeight = menuHeight + 'px';
        }, 100)
      );
    }
  
    listen() {
      this.options.forEach((option) => {
        option.addEventListener("click", () => {
          this.close();
        });
      });
  
      this.trigger.addEventListener("focusin", () => {
        if (document.body.classList.contains("outlines")) {
          this.open();
        }
      });
  
      this.options.forEach((option) => {
        option.addEventListener("focusout", () => {
          this.close();
        });
      });
  
      this.menu.addEventListener("focusin", () => {
        this.open();
      });
  
      this.trigger.addEventListener("click", () => {
        this.set_width();
        if (this.el.classList.contains("active")) {
          this.close();
        } else {
          this.open();
        }
      });
    }
    set_width() {
      let max = 0;
      const padding = parseInt(window.getComputedStyle(this.inner).padding);
      this.inner.style.width = "200%";
  
      this.options.forEach((option) => {
        const w = option.offsetWidth;
        if (w > max) {
          max = w;
        }
      });
      this.menu.style.width = `${max + padding * 2}px`;
    }
}